/**
 * Modal의 샘플용 화면
 */

import axios from 'axios'

export default {
  computed: {
  }, // end computed
  methods: {
    /** 버튼1 이벤트 처리 */
    onClickButton1 () {
      let gLoadingBar = this.$store.getters.loadingBars.gLoadingBar// Store에 있는 Global 로딩바(App.vue에서 설정함)
      gLoadingBar.show()
    },

    /** 버튼2 이벤트 처리 */
    onClickButton2 () {
      this.isLocalLoadingBar1 = !this.isLocalLoadingBar1
    },

    /** 버튼3 이벤트 처리 */
    onClickButton3 () {
      const url = `http://localhost:15040/fdc/mts/code-type/list`
      axios
        .get(url, {})
        .then((response) => {
          this.$buefy.toast.open({
            message: '데이터 조회가 완료되었습니다.',
            type: 'is-success',
            queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },

    /** 버튼4 이벤트 처리 */
    onClickButton4 () {
      const url = `http://localhost:15040/fdc/mts/code-type/list`
      axios
        .get(url, { isLoadingBar: false }) // 로딩바 띄우지 않음
        .then((response) => {
          this.$buefy.toast.open({
            message: '데이터 조회가 완료되었습니다.',
            type: 'is-success',
            queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },

    /** 버튼4 이벤트 처리 */
    onClickButton5 () {
      const url = `http://localhost:15040/fdc/mts/code-type/list`
      axios
        .get(url, { loadingBarId: 'localLoadingBar2' }) // 로딩바 띄우지 않음
        .then((response) => {
          this.$buefy.toast.open({
            message: '데이터 조회가 완료되었습니다.',
            type: 'is-success',
            queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },

    /** 로컬 로딩바 표시 영역2 이벤트 처리 */
    onClickDivLocalLoadingBar2 () {
      this.$refs.localLoadingBar2.show()
    }
  }, // end methods
  watch: {
  },
  data () {
    return {
      isLocalLoadingBar1: false // 로컬 로딩바 표시 영역1의 보이기 유무
    }
  }
}
